import {
  Box,
  Button,
  Paper,
  Typography,
  TextField,
  Grid,
  Divider,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  Card,
  CardContent,
} from "@mui/material";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import * as services from "../../services/services";
import * as Dropdownservices from "../../services/dropdown_service";
import { jwtDecode } from "jwt-decode";
import { Autocomplete } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import PersonIcon from "@mui/icons-material/Person";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
const accessToken = localStorage.getItem("accessToken");
let decoded;
if (accessToken) {
  decoded = jwtDecode(accessToken);
} else {
  console.warn("No access token found!");
  // handle กรณี user ยัง login ไม่ได้ หรือ redirect
}
const PetCreate = () => {
  const navigate = useNavigate();
  const [ageInput, setAgeInput] = useState({
    years: "",
    months: "",
  });
  const [pet, setPet] = useState({
    name: "",
    type: "",
    breed: "",
    typeId: "",
    breedId: "",
    eyeColor: "",
    furColor: "",
    gender: "",
    neutered: "",
    sterilizationDate: null,
    birthdate: null,
    image: "",
    appearanceDetail: "",
    microchipNumber: "",
    otherReferenceNumbers: "",
    bloodGroup: "",
    drugAllergies: "",
    foodAllergies: "",
    diseases: "",
    fatherName: "",
    fatherMicrochipNumber: "",
    motherName: "",
    motherMicrochipNumber: "",
    certificates: "",
    photos: "",
    ownerName: "",
    ownerIdCard: "",
    hospitalId: decoded.hospitalId,
    ownerId: null,
  });
  const [petTypes, setPetTypes] = useState([]);
  const [petBreeds, setPetBreeds] = useState([]);
  const [filteredBreeds, setFilteredBreeds] = useState([]);
  const [imageFile, setImageFile] = useState(null);
  const [openOwnerDialog, setOpenOwnerDialog] = useState(false);
  const [selectedOwnerId, setSelectedOwnerId] = useState("");
  const [owners, setOwners] = useState([]);
  const [selectedOwner, setSelectedOwner] = useState(null);
  const [mode, setMode] = useState("select"); // select | create
  const [newOwner, setNewOwner] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    idCard: "",
    address: "",
    subDistrict: "",
    district: "",
    province: "",
  });
  const [search, setSearch] = useState("");

  const filteredOwners =
    search.trim() === ""
      ? []
      : owners.filter((o) => {
          const keyword = search.toLowerCase();
          return (
            `${o.firstName} ${o.lastName}`.toLowerCase().includes(keyword) ||
            o.phoneNumber?.includes(search) ||
            o.ownerCode?.includes(search) ||
            o.idCard?.includes(search)
          );
        });
  const fetchOwners = async () => {
    const res = await services.getOwnersByHospital();
    setOwners(res.data.data);
  };

  useEffect(() => {
    fetchPet();

    fetchOwners();
  }, []);
  const fetchPet = async () => {
    let pet_type = await Dropdownservices.getPetType();
    let pet_breed = await Dropdownservices.getPetBreed();
    setPetTypes(pet_type.data);
    setPetBreeds(pet_breed.data);
  };
  const handleTypeChange = (e) => {
    const typeId = e.target.value;
    const selectedType = petTypes.find((t) => t.id === typeId);

    setPet((prev) => ({
      ...prev,
      typeId: typeId,
      type: selectedType?.name || "",
      breedId: "",
      breed: "",
    }));

    const breeds = petBreeds.filter((b) => b.pet_type === typeId);
    setFilteredBreeds(breeds);
  };
  const handleBreedChange = (e) => {
    const breedId = e.target.value;
    const selectedBreed = filteredBreeds.find((b) => b.id === breedId);

    setPet((prev) => ({
      ...prev,
      breedId: breedId,
      breed: selectedBreed?.name || "",
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPet((prev) => ({ ...prev, [name]: value }));
  };
  const handleNeuteredChange = (e) => {
    const value = e.target.value;

    setPet((prev) => ({
      ...prev,
      neutered: value,
      sterilizationDate: value === "yes" ? prev.sterilizationDate : null,
    }));
  };

  //   const buildPayload = () => ({
  //     pet: Object.fromEntries(Object.entries(pet).filter(([_, v]) => v !== "")),
  //   });

  const buildPayload = (imageUrl) => {
    const rawData = {
      ...pet,
      image: imageUrl?.data?.url ?? pet.image,
      birthdate: pet.birthdate ? new Date(pet.birthdate) : null,
      sterilizationDate: pet.sterilizationDate
        ? new Date(pet.sterilizationDate)
        : null,
    };

    // ฟิลด์ที่เป็น optional ถ้าไม่ได้กรอกให้เป็น "-"
    const optionalFields = [
      "appearanceDetail",
      "microchipNumber",
      "otherReferenceNumbers",
      "bloodGroup",
      "drugAllergies",
      "foodAllergies",
      "diseases",
      "fatherName",
      "fatherMicrochipNumber",
      "motherName",
      "motherMicrochipNumber",
      "certificates",
      "ownerName",
      "ownerIdCard",
      "eyeColor",
      "furColor",
    ];

    optionalFields.forEach((field) => {
      if (!rawData[field] || rawData[field].toString().trim() === "") {
        rawData[field] = "-";
      }
    });

    return {
      pet: Object.fromEntries(
        Object.entries(rawData).filter(([k, v]) => v !== "" && v !== null),
      ),
    };
  };
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setImageFile(file);

    const previewUrl = URL.createObjectURL(file);
    setPet((prev) => ({
      ...prev,
      image: previewUrl, // preview เท่านั้น
    }));
  };

  const handleCreateOwner = async () => {
    if (!newOwner.idCard) {
      toast.error("กรุณากรอกเลขบัตรประชาชน");
      return;
    }

    try {
      const res = await services.createOwner(newOwner);

      console.log("OWNER RESPONSE:", res.data);

      const createdOwner = res?.data?.data;

      if (!createdOwner) {
        toast.error("เกิดข้อผิดพลาด: ไม่พบข้อมูลเจ้าของ");
        return;
      }

      toast.success("เพิ่มเจ้าของสำเร็จ");

      setOwners((prev) => [...prev, createdOwner]);

      setPet((prev) => ({
        ...prev,
        ownerId: createdOwner.id,
        owner: createdOwner,
      }));

      setSelectedOwnerId(createdOwner.id);

      setMode("select");
      setOpenOwnerDialog(false);

      setNewOwner({
        firstName: "",
        lastName: "",
        phoneNumber: "",
        idCard: "",
        address: "",
        subDistrict: "",
        district: "",
        province: "",
      });
    } catch (err) {
      console.log(err);

      if (err?.response?.status === 409) {
        toast.error("มีเลขบัตรนี้ในระบบแล้ว");
      } else {
        toast.error("เพิ่มเจ้าของไม่สำเร็จ");
      }
    }
  };

  const handleChangeOwner = async () => {
    const owner = owners.find((o) => o.id === selectedOwnerId);

    setPet((prev) => ({
      ...prev,
      ownerId: selectedOwnerId,
      owner: owner, // (optional) เอาไว้โชว์ชื่อ
    }));

    setOpenOwnerDialog(false);
    toast.success("เลือกเจ้าของเรียบร้อย");
  };
  const handleSubmit = async () => {
    if (!pet.name || !pet.hospitalId) {
      toast.error("กรุณากรอกข้อมูลที่จำเป็น");
      return;
    }
    if (!pet.ownerId) {
      toast.error("กรุณาเพิ่มเจ้าของสัตว์เลี้ยง");
      return;
    }
    try {
      let imageUrl = null;

      if (imageFile) {
        imageUrl = await services.uploadImage(imageFile, "pet");
      }

      const payload = buildPayload(imageUrl);
      console.log(payload);
      let res = await services.createPet(payload);
      toast.success("สร้างสัตว์เลี้ยงสำเร็จ");
      setTimeout(() => {
        navigate("/pets/" + res.data.data.id);
      }, 800);
    } catch (e) {
      console.log(e);
      toast.error("บันทึกไม่สำเร็จ");
    }
  };
  const genderOptions = [
    { value: "m", label: "เพศผู้" },
    { value: "f", label: "เพศเมีย" },
    { value: "b", label: "ไม่ทราบ" },
  ];
  const neuteredOptions = [
    { value: "yes", label: "ทำแล้ว" },
    { value: "no", label: "ยังไม่ทำ" },
  ];
  useEffect(() => {
    if (pet.birthdate) {
      const age = calculateAgeFromBirthdate(pet.birthdate);
      setAgeInput({
        years: age.years,
        months: age.months,
      });
    }
  }, [pet.birthdate]);

  const calculateAgeFromBirthdate = (birthdate) => {
    if (!birthdate) return { years: "", months: "" };

    const birth = new Date(birthdate);
    const today = new Date();

    let years = today.getFullYear() - birth.getFullYear();
    let months = today.getMonth() - birth.getMonth();

    if (today.getDate() < birth.getDate()) {
      months -= 1;
    }

    if (months < 0) {
      years -= 1;
      months += 12;
    }

    return { years, months };
  };
  const calculateBirthdateFromAge = (years, months) => {
    if (years === "" && months === "") return null;

    const today = new Date();
    const birth = new Date(today);

    birth.setFullYear(today.getFullYear() - Number(years || 0));
    birth.setMonth(today.getMonth() - Number(months || 0));

    return birth.toISOString().split("T")[0];
  };

  return (
    <>
      <AppBreadcrumbs />
      <Toaster position="bottom-left" />

      <Paper sx={{ p: 3, maxWidth: 1200, mx: "auto" }}>
        <Typography variant="h5">เพิ่มสัตว์เลี้ยง</Typography>
        <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
          <Box
            sx={{
              width: 200,
              height: 200,
              borderRadius: 2,
              border: "1px dashed #ccc",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              position: "relative",
              overflow: "hidden",
              "&:hover": { opacity: 0.9 },
            }}
            component="label"
          >
            {pet.image ? (
              <img
                src={pet.image}
                alt="pet"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            ) : (
              <Typography color="text.secondary">
                คลิกเพื่ออัปโหลดรูป
              </Typography>
            )}

            <input
              hidden
              accept="image/*"
              type="file"
              onChange={handleImageUpload}
            />
          </Box>
        </Box>
        <Section title="ข้อมูลเจ้าของ">
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {/* ซ้าย: ข้อมูลเจ้าของ */}
              <Box>
                {pet?.owner ? (
                  <Box sx={{ pl: 2, mt: 0.5 }}>
                    <Typography>
                      <b>ชื่อ:</b> {pet.owner.firstName} {pet.owner.lastName}
                    </Typography>

                    <Typography>
                      <b>โทร:</b> {pet.owner.phoneNumber || "-"}
                    </Typography>

                    <Typography>
                      <b>ที่อยู่:</b>{" "}
                      {[
                        `${pet.owner.address}`,
                        `ตำบล ${pet.owner.subDistrict ?? "-"}`,
                        `อำเภอ ${pet.owner.district ?? "-"}`,
                        `จังหวัด ${pet.owner.province ?? "-"}`,
                      ]
                        .filter(Boolean)
                        .join(" ")}
                    </Typography>
                  </Box>
                ) : (
                  <Typography color="text.secondary">ไม่มีเจ้าของ</Typography>
                )}
              </Box>

              {/* ขวา: ปุ่ม */}
              <Button
                size="small"
                variant="outlined"
                startIcon={<PersonIcon />}
                onClick={() => {
                  setMode("select");
                  setOpenOwnerDialog(true);
                }}
              >
                เพิ่ม/เปลี่ยน เจ้าของ
              </Button>
            </Box>
          </Grid>
        </Section>
        {/* ================= ข้อมูลหลัก ================= */}
        <Section title="ข้อมูลหลัก">
          <Field
            label="ชื่อสัตว์เลี้ยง *"
            name="name"
            value={pet.name}
            onChange={handleChange}
          />
          <Grid item xs={4} sm={2}>
            {/* <DateField
              label="วันเกิด"
              name="birthdate"
              value={pet.birthdate}
              onChange={handleChange}
              fullWidth
            /> */}
            <TextField
              label="วันเกิด"
              name="birthdate"
              type="date"
              value={pet.birthdate}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
          </Grid>

          <Grid item xs={4} sm={2}>
            <TextField
              label="อายุ (ปี)"
              type="number"
              value={ageInput.years}
              onChange={(e) => {
                const years = e.target.value;
                const months = ageInput.months;

                setAgeInput({ years, months });

                const birthdate = calculateBirthdateFromAge(years, months);
                setPet((prev) => ({ ...prev, birthdate }));
              }}
              fullWidth
            />
          </Grid>

          <Grid item xs={4} sm={2}>
            <TextField
              label="อายุ (เดือน)"
              type="number"
              value={ageInput.months}
              onChange={(e) => {
                const months = e.target.value;
                const years = ageInput.years;

                setAgeInput({ years, months });

                const birthdate = calculateBirthdateFromAge(years, months);
                setPet((prev) => ({ ...prev, birthdate }));
              }}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              select
              label="ชนิดสัตว์ *"
              fullWidth
              value={pet.typeId || ""}
              onChange={handleTypeChange}
            >
              {petTypes.map((type) => (
                <MenuItem key={type.id} value={type.id}>
                  {type.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          {/* BREED */}
          <Grid item xs={12} sm={6}>
            <TextField
              select
              label="สายพันธุ์"
              fullWidth
              value={pet.breedId || ""}
              onChange={handleBreedChange}
              disabled={!pet.typeId}
            >
              {filteredBreeds.map((breed) => (
                <MenuItem key={breed.id} value={breed.id}>
                  {breed.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              select
              label="เพศ"
              name="gender"
              fullWidth
              value={pet.gender || ""}
              onChange={handleChange}
            >
              {genderOptions.map((g) => (
                <MenuItem key={g.value} value={g.value}>
                  {g.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Section>

        {/* ================= ลักษณะภายนอก ================= */}
        <Section title="ลักษณะภายนอก">
          <Field
            label="สีตา"
            name="eyeColor"
            value={pet.eyeColor}
            onChange={handleChange}
          />
          <Field
            label="สีขน"
            name="furColor"
            value={pet.furColor}
            onChange={handleChange}
          />
          <Field
            label="ลักษณะเด่น"
            name="appearanceDetail"
            value={pet.appearanceDetail}
            onChange={handleChange}
          />
          {/* <Field label="รูปหลัก (URL)" name="image" value={pet.image} onChange={handleChange} /> */}
          {/* <Field label="รูปเพิ่มเติม" name="photos" value={pet.photos} onChange={handleChange} /> */}
        </Section>

        {/* ================= สุขภาพ ================= */}
        <Section title="ข้อมูลสุขภาพ">
          <Field
            label="กรุ๊ปเลือด"
            name="bloodGroup"
            value={pet.bloodGroup}
            onChange={handleChange}
          />
          <Field
            label="โรคประจำตัว"
            name="diseases"
            value={pet.diseases}
            onChange={handleChange}
          />
          <Field
            label="แพ้ยา"
            name="drugAllergies"
            value={pet.drugAllergies}
            onChange={handleChange}
          />
          <Field
            label="แพ้อาหาร"
            name="foodAllergies"
            value={pet.foodAllergies}
            onChange={handleChange}
          />
        </Section>

        {/* ================= การทำหมัน ================= */}
        <Section title="การทำหมัน">
          <Grid item xs={12} sm={6}>
            <TextField
              select
              label="ทำหมันหรือไม่"
              name="neutered"
              fullWidth
              value={pet.neutered || ""}
              onChange={handleNeuteredChange}
            >
              {neuteredOptions.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          {pet.neutered === "yes" && (
            <DateField
              label="วันที่ทำหมัน"
              name="sterilizationDate"
              value={pet.sterilizationDate}
              onChange={handleChange}
            />
          )}
        </Section>

        {/* ================= ไมโครชิพ ================= */}
        <Section title="ไมโครชิพ / อ้างอิง">
          <Field
            label="หมายเลขไมโครชิพ"
            name="microchipNumber"
            value={pet.microchipNumber}
            onChange={handleChange}
          />
          <Field
            label="เลขอ้างอิงอื่น"
            name="otherReferenceNumbers"
            value={pet.otherReferenceNumbers}
            onChange={handleChange}
          />
        </Section>

        {/* ================= พ่อ–แม่ ================= */}
        <Section title="ข้อมูลพ่อ–แม่">
          <Field
            label="ชื่อพ่อ"
            name="fatherName"
            value={pet.fatherName}
            onChange={handleChange}
          />
          <Field
            label="ไมโครชิพพ่อ"
            name="fatherMicrochipNumber"
            value={pet.fatherMicrochipNumber}
            onChange={handleChange}
          />
          <Field
            label="ชื่อแม่"
            name="motherName"
            value={pet.motherName}
            onChange={handleChange}
          />
          <Field
            label="ไมโครชิพแม่"
            name="motherMicrochipNumber"
            value={pet.motherMicrochipNumber}
            onChange={handleChange}
          />
        </Section>

        {/* ================= เจ้าของ ================= */}
        {/* <Section title="ข้อมูลเจ้าของ">
          <Field label="ชื่อเจ้าของ *" name="ownerName" value={pet.ownerName} onChange={handleChange} />
          <Field label="เลขบัตรประชาชน" name="ownerIdCard" value={pet.ownerIdCard} onChange={handleChange} />
          <Field label="Hospital ID *" name="hospitalId" value={pet.hospitalId} onChange={handleChange} />
        </Section> */}

        {/* ================= Actions ================= */}
        <Box
          sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 4 }}
        >
          <Button variant="outlined" onClick={() => navigate("/pets")}>
            ยกเลิก
          </Button>
          <Button variant="contained" onClick={handleSubmit}>
            บันทึก
          </Button>
        </Box>
      </Paper>
      <Dialog open={openOwnerDialog} onClose={() => setOpenOwnerDialog(false)}>
        <DialogTitle>
          {mode === "select" ? "เปลี่ยนเจ้าของสัตว์เลี้ยง" : "เพิ่มเจ้าของใหม่"}
        </DialogTitle>

        <DialogContent sx={{ minWidth: 600 }}>
          {mode === "select" ? (
            <>
              {/* ช่องค้นหา */}
              <TextField
                fullWidth
                sx={{ mt: 2 }}
                label="ค้นหาเจ้าของ (OwnerID/ ชื่อ / เบอร์โทร)"
                placeholder="พิมพ์ชื่อหรือเบอร์โทร"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />

              {/* ปุ่มเพิ่มเจ้าของ */}
              <Button
                startIcon={<AddIcon />}
                sx={{ mt: 2 }}
                onClick={() => setMode("create")}
              >
                เพิ่มเจ้าของใหม่
              </Button>

              {/* แสดงผลลัพธ์เมื่อมีการค้นหาแล้วเท่านั้น */}
              {search.trim() !== "" && (
                <Grid container spacing={2} sx={{ mt: 2 }}>
                  {filteredOwners.map((owner) => (
                    <Grid item xs={12} md={6} key={owner.id}>
                      <Card
                        sx={{
                          cursor: "pointer",
                          border:
                            selectedOwnerId === owner.id
                              ? "2px solid"
                              : "1px solid #e0e0e0",
                          borderColor:
                            selectedOwnerId === owner.id
                              ? "primary.main"
                              : undefined,
                        }}
                        onClick={() => setSelectedOwnerId(owner.id)}
                      >
                        <CardContent>
                          <Typography>{owner.ownerCode}</Typography>
                          <Typography>
                            {owner.firstName} {owner.lastName}
                          </Typography>
                          <Typography color="text.secondary">
                            เบอร์โทร: {owner.phoneNumber || "-"}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}

                  {filteredOwners.length === 0 && (
                    <Grid item xs={12}>
                      <Typography align="center" color="text.secondary">
                        ไม่พบข้อมูล
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              )}
            </>
          ) : (
            <>
              <TextField
                label="ชื่อ"
                fullWidth
                sx={{ mt: 1 }}
                value={newOwner.firstName}
                onChange={(e) =>
                  setNewOwner({ ...newOwner, firstName: e.target.value })
                }
              />
              <TextField
                label="นามสกุล"
                fullWidth
                sx={{ mt: 2 }}
                value={newOwner.lastName}
                onChange={(e) =>
                  setNewOwner({ ...newOwner, lastName: e.target.value })
                }
              />
              <TextField
                label="เลขบัตรประชาชน"
                fullWidth
                sx={{ mt: 2 }}
                value={newOwner.idCard}
                onChange={(e) =>
                  setNewOwner({ ...newOwner, idCard: e.target.value })
                }
              />
              <TextField
                label="เบอร์โทร"
                fullWidth
                sx={{ mt: 2 }}
                value={newOwner.phoneNumber}
                onChange={(e) =>
                  setNewOwner({ ...newOwner, phoneNumber: e.target.value })
                }
              />{" "}
              <TextField
                label="ที่อยู่"
                fullWidth
                sx={{ mt: 2 }}
                value={newOwner.address}
                onChange={(e) =>
                  setNewOwner({ ...newOwner, address: e.target.value })
                }
              />{" "}
              <TextField
                label="ตำบล"
                fullWidth
                sx={{ mt: 2 }}
                value={newOwner.subDistrict}
                onChange={(e) =>
                  setNewOwner({ ...newOwner, subDistrict: e.target.value })
                }
              />
              <TextField
                label="อำเภอ"
                fullWidth
                sx={{ mt: 2 }}
                value={newOwner.district}
                onChange={(e) =>
                  setNewOwner({ ...newOwner, district: e.target.value })
                }
              />{" "}
              <TextField
                label="จังหวัด"
                fullWidth
                sx={{ mt: 2 }}
                value={newOwner.province}
                onChange={(e) =>
                  setNewOwner({ ...newOwner, province: e.target.value })
                }
              />
            </>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              if (mode === "create") {
                setMode("select");
              } else {
                setOpenOwnerDialog(false);
              }
            }}
          >
            ยกเลิก
          </Button>

          {mode === "select" ? (
            <Button
              variant="contained"
              disabled={!selectedOwnerId}
              onClick={handleChangeOwner}
            >
              บันทึก
            </Button>
          ) : (
            <Button variant="contained" onClick={handleCreateOwner}>
              บันทึกเจ้าของ
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

/* ===== Helper Components ===== */

const Section = ({ title, children }) => (
  <>
    <Typography sx={{ mt: 4 }}>{title}</Typography>
    <Divider sx={{ mb: 2 }} />
    <Grid container spacing={2}>
      {children}
    </Grid>
  </>
);

const Field = ({ label, name, value, onChange }) => (
  <Grid item xs={12} sm={6}>
    <TextField
      label={label}
      name={name}
      fullWidth
      value={value || ""}
      onChange={onChange}
    />
  </Grid>
);

const DateField = ({ label, name, value, onChange }) => (
  <Grid item xs={12} sm={6}>
    <TextField
      label={label}
      name={name}
      type="date"
      fullWidth={true}
      InputLabelProps={{ shrink: true }}
      value={value || ""}
      onChange={onChange}
    />
  </Grid>
);

export default PetCreate;
